import React, { Component, type ReactNode, type ErrorInfo } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

import airbrake from 'helpers/airbrake';

type Props = {
  children: ReactNode,
  fallback?: ReactNode,
};

type State = {
  hasError: boolean,
};

// See Note, this has to be a class component:
// https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    if (info.componentStack.includes('RetailerMapEditor')) return;

    airbrake.notify({
      error,
      params: {
        info,
      },
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="text-center p-4">
          <h3 className="mb-6">
            <FontAwesomeIcon className="icon-gradient me-3" icon={faExclamationTriangle} />
            Oops, something went wrong.
          </h3>
          <p>Please try again or contact support.</p>
        </div>
      );
    }

    return this.props.children;
  }
}
